import { StarRating } from './StarRating';
import type { ProfessionalReview } from '../services/professional-reviews.service';

const dateFormatter = new Intl.DateTimeFormat('it-IT', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

function formatReviewDate(iso: string): string {
  return dateFormatter.format(new Date(iso));
}

interface ReviewListItemProps {
  review: ProfessionalReview;
  professionalName: string;
}

export function ReviewListItem({ review, professionalName }: ReviewListItemProps) {
  const initial = review.authorName.trim().charAt(0).toUpperCase() || '?';

  return (
    <div className="flex items-start gap-3 py-4">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-sm font-semibold text-white">
        {initial}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center justify-between gap-3">
          <span className="truncate font-medium text-white">{review.authorName}</span>
          <span className="shrink-0 text-xs text-white/40">
            {formatReviewDate(review.createdAt)}
          </span>
        </div>
        <div className="mt-1">
          <StarRating rating={review.rating} size="sm" />
        </div>
        {review.feedback && (
          <p className="mt-2 text-sm text-white/70">{review.feedback}</p>
        )}
        {review.reply && (
          <div className="mt-3 rounded-lg border-l-2 border-brand-teal/60 bg-white/5 px-3 py-2">
            <p className="text-xs font-semibold text-white/80">
              Risposta di {professionalName}
            </p>
            <p className="mt-1 text-sm text-white/70">{review.reply.text}</p>
            <p className="mt-1 text-[11px] text-white/40">
              {formatReviewDate(review.reply.repliedAt)}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
